var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserSponsor28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM7 21.253a7.603 7.603 0 0 1 3.91-6.646l.446-.248c.278-.154.417-.232.55-.3a10 10 0 0 1 9.189 0c.132.068.271.146.55.3l.445.248A7.603 7.603 0 0 1 26 21.253c0 1.336-.929 2.488-2.25 2.686-1.754.264-4.368.561-7.25.561-2.882 0-5.496-.297-7.25-.56C7.93 23.74 7 22.59 7 21.252Zm-2.1-5.005a.854.854 0 0 0 .63.252.854.854 0 0 0 .63-.252.854.854 0 0 0 .251-.63v-.68c.773-.142 1.398-.453 1.877-.931.478-.479.717-1.075.717-1.788 0-1.285-.78-2.103-2.342-2.456L5.228 9.45c-.37-.084-.626-.18-.768-.29a.549.549 0 0 1-.202-.428c0-.252.118-.458.353-.617.243-.16.587-.24 1.032-.24.37 0 .672.03.907.089.235.05.453.117.655.201.327.135.596.156.805.063a.85.85 0 0 0 .454-.466 1.01 1.01 0 0 0 .025-.667c-.059-.235-.21-.42-.453-.554a3.007 3.007 0 0 0-.781-.34 6.372 6.372 0 0 0-.844-.189v-.63a.854.854 0 0 0-.251-.63.854.854 0 0 0-.63-.251.854.854 0 0 0-.63.252.878.878 0 0 0-.239.63v.68c-.797.15-1.435.474-1.914.969-.47.487-.705 1.083-.705 1.788 0 1.326.772 2.162 2.317 2.506l1.423.302c.378.084.638.189.78.315a.548.548 0 0 1 .215.44c0 .202-.105.378-.315.53-.21.142-.575.213-1.096.213-.512 0-.936-.05-1.272-.15a5.026 5.026 0 0 1-.755-.278c-.252-.109-.474-.134-.667-.075a.818.818 0 0 0-.454.315c-.117.159-.189.34-.214.541-.017.193.017.382.1.567a.95.95 0 0 0 .467.415c.226.11.512.218.856.327.353.101.764.173 1.234.215v.617c0 .251.08.461.24.63Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSponsor28);
export default __webpack_public_path__ + "static/media/user_sponsor_28.27889bd8.svg";
export { ForwardRef as ReactComponent };